<template>
  <div class="item-actionsv2">
    <div class="share-item-section square">
      <div class="d-none d-sm-block">
        <div class="title">
          {{ shareCopy }}
        </div>
        <div class="share-url d-flex align-items-center">
          {{ item.links.share_url.replace(/(^\w+:|^)\/\//, '') }}
          <copy-to-clipboard :value="item.links.share_url">Link copied</copy-to-clipboard>
        </div>
      </div>
      <div class="copy-to-clipboard-wrapper">
        <a href="#" title="Share Drop" id="shareDropModal" data-testid="shareDropModal" data-dismiss="modal" data-toggle="modal" @click="track('open_share_item_modal')" data-target="#shareModal" class="copy-to-clipboard cloudapp-btn blue">
          <i class="fas fa-paper-plane"></i>
          Share
        </a>
        <div v-if="isOwner" id="one-time-tooltip" class="one-time-tooltip">
          <div>
            <div class="one-time-tooltip-header">
              Congrats, you made your first {{ item.attributes.item_type || 'item' }} 🎉
              <span id="close-one-time-tooltip"> <i class="fas fa-times-circle tooltip-close"></i> </span>
            </div>
            <div class="one-time-tooltip-text">
              A unique link is always created and copied to your clipboard instantly. Now share it!
              <br>
              <a :href="onboardingVideoUrl" class="font-color-bright-blue font-size-10" target="_blank" data-testid="learn-more-about-cloudapp-viewer">
                Learn more
              </a>
            </div>
          </div>
          <div class="arrow-right"></div>
        </div>
      </div>
    </div>
    <template v-if="isOwner || itemOrganization.attributes.preferences.download_button != false">
      <template v-if="isOwner">
        <div v-if="!$root.customDomainOrigin" class="d-none d-sm-block">
          <template v-if="!currentOrganization.attributes.is_paying">
            <div class="bottom-section flex square">
              <div class="customize-container">
                <label for="comments_disabled">Customize page</label>
                <pro-badge :visible="currentOrganization.attributes.plan_code == 'free' || currentOrganization.attributes.trial" :trial="currentOrganization.attributes.trial" :learnmore_url="$root.routes.customize_settings_organization_path(currentOrganization.id || '')" utm_source="viewer" utm_campaign="upgrade" utm_medium="customize"></pro-badge>
              </div>
              <a :href="$root.routes.customize_settings_organization_path(currentOrganization.id || '')" title="Customize" data-testid="footer-actions-customise">
                <span class="action-label edit-label">Edit</span>
              </a>
            </div>
          </template>
          <template v-else>
            <form id="comments-enable-form">
              <div class="bottom-section flex square">
                <label for="comments_disabled">Anyone can comment</label>
                <input type="checkbox" data-testid="disable-commenting" name="comments_disabled" v-model="commentsEnabled">
              </div>
            </form>
          </template>
        </div>
      </template>
      <template v-else-if="!itemOrganization.attributes.preferences.hide_cloudapp_branding && !viewOnlyUser">
        <div class="bottom-section square save-drop">
          <template v-if="$root.userLoggedIn">
            <a
              v-if="!viewOnlyUser && showCopyDrop"
              title="Copy Drop"
              data-testid="footer-actions-copy"
              :href="$root.routes.copy_item_url(item.id || '')"
            >
              <span class="action-label">Save to my CloudApp</span>
            </a>
          </template>
          <template v-else>
            <a
              v-if="$root.customDomainOrigin"
              :href="$root.routes.login_url({ host: gon.baseWebDomain, return_to: $root.routes.copy_item_url({ host: gon.baseWebDomain, id: item.id }) })">
                <span class="action-label">Save to my CloudApp</span>
            </a>
            <a v-else-if="showCopyDrop" href="#" v-b-modal.signup-modal title="Save Drop" data-testid="footer-actions-copy" @click="setUtmParams">
              <span class="action-label">Save to my CloudApp</span>
            </a>
          </template>
        </div>
      </template>

      <div class="actions-section">
        <div v-if="item.attributes.uploading || item.attributes.instant_video" class="big-action-item left-item disabled">
          <a>
            <i class="fa fa-download align-text-top" data-toggle="tooltip" data-placement="top" title="Download not yet available"></i>
            <p class="owner-action-label">
              <span class="hover-visible">(Processing ...)</span>
              <span class="hover-hidden">Download</span>
            </p>
          </a>
        </div>
        <div v-else class="big-action-item left-item">
          <a data-testid="footer-actions-download" title="Download Drop" :href="$root.routes.viewer_download_item_url({ slug: item.id, filename: item.attributes.name, utm_source: 'viewer' })">
            <i class="fa fa-download align-text-top" data-toggle="tooltip" data-placement="top" title="Download"></i>
            <div class="owner-action-label">Download</div>
          </a>
        </div>
        <!-- # See comments in upgrade_modal.vue for that last condition %> -->
        <div class="big-action-item right-item" v-if="templatesEnabled">
          <pro-link id="template" title="Apply template (beta)" @pro-click="$bvModal.show('template-modal')" @free-click="$bvModal.show('b-upgrade-modal')" :icon="require('@img/icons-magic.svg')">
            Apply template (beta)
          </pro-link>
          <div class="popover-template" v-if="gon.show_viewer_templates_coachmark">
            <popover
              id="popover-target-template"
              heading="New! Templates"
              content="Enhance your content and speed up your workflow!"
              placement="right"
              image="comments"
              event="viewer_coachmark_viewed"
              :eventParams="{ feature: 'templates' }"
            >
            </popover>
          </div>
        </div>


        <div class="big-action-item right-item d-sm-none">
            <!-- this makes a js formatted request to insert the collections modal, need to refactor it. -->
            <a id="add-to-collection" title="Add To Collection" data-testid="footer-actions-add-to-collection" :data-remote="!viewOnlyUser" :href="addToCollectionURL">
            <i class="fas fa-plus-square align-text-top"></i>
            <p class="owner-action-label">Collection</p>
          </a>
        </div>
      </div>
      <!-- we show this only for owners and view only users so we prompt the latter to ask for a seat -->
      <div class="actions-section" v-if="isOwner || viewOnlyUser">
        <div class="big-action-item left-item d-none d-sm-block">
          <a href="#" title="Add Button" data-testid="cta-menu-link" v-b-toggle.cta-sidebar>
            <img v-if="currentOrganization.attributes.free || currentOrganization.attributes.trial" :src="require('@img/pro-ribbon.png')" class="img-pro-ribbon" data-testid="img-pro-ribbon" />
            <i class="fas fa-mouse-click align-text-top" data-toggle="tooltip" data-placement="top" title="Add button"></i>
            <div class="owner-action-label">Add Button</div>
          </a>
        </div>
        <div v-if="!item.uploading && allowWebAnnotation" class="big-action-item middle-item d-none d-md-block">
          <router-link
            data-testid="viewer-annotate-link"
            :to="webAnnotateRoute">
            <i class="icon-annotate align-text-top"></i>
            <p class="owner-action-label">Annotate</p>
          </router-link>
        </div>
        <div v-else-if="gon.showAnnotateInClient && !item.attributes.uploading && annotable" class="big-action-item middle-item d-none d-md-block">
          <a :href="annotateInClientUrl" @click="trackClientAnnotate" data-testid="viewer-annotate-link">
            <i class="icon-video-trim align-text-top"></i>
            <div class="owner-action-label">
              <span v-if="item.attributes.item_type == 'video'">Trim/Cut</span>
              <span v-else>Annotate</span>
            </div>
          </a>
        </div>
        <div class="big-action-item right-item d-none d-sm-block">
          <!-- this makes a js formatted request to insert the collections modal, need to refactor it. -->
          <a id="add-to-collection" title="Add To Collection" data-testid="footer-actions-add-to-collection" :data-remote="!viewOnlyUser" :href="addToCollectionURL">
          <i class="fas fa-plus-square align-text-top"></i>
          <p class="owner-action-label">Collection</p>
        </a>
        </div>
      </div>
    </template>
</div>

</template>

<script>
import { mapState } from 'vuex';
import featureKey from '../../feature_key.macro';
import track from '@/src/tracking';

export default {
  props: {
    isOwner: { required: true, type: Boolean }
  },
  data: function(){
    return {
      onboardingVideoUrl: ''
    }
  },
  created: function(){
    const vm = this;
    vm.$store.dispatch('getConfiguration', 'viewer_onboarding_video').then((response) => vm.onboardingVideoUrl = response.data.data.dropper_configuration?.attributes?.content)
  },
  computed: {
    ...mapState({
      currentUser: state => state.user,
      item: state => state.item,
      itemOrganization: state => state.itemOrganization,
      currentOrganization: state => state.currentOrganization,
      features: state => state.features,
      viewOnlyUser: state => state.itemOrganization.attributes.current_user_view_only
    }),
    addToCollectionURL: function(){
      if(this.viewOnlyUser){
        return "#view-only";
      }else{
        return this.$root.routes.collections_organization_url(this.currentOrganization.id || '', { item_id: this.item.id });
      }
    },
    annotable: function () {
      if (this.item.attributes.item_type != "video" && this.item.attributes.item_type != "image") {
        return false;
      }
      return true;
    },
    annotateInClientUrl: function(){
      const link = "cloudapp://annotate/" + this.item.id;

      if(this.$root.userLoggedIn){
        return link + "?jwt=" + this.currentUser.attributes.jwt_token;
      }

      return link;
    },
    allowWebAnnotation: function () {
      if (this.item.attributes.item_type !== "image") {
        return false;
      }
      if (this.item.attributes.file_ext == ".gif") {
        return false;
      }
      return true;
    },
    commentsEnabled: {
      get: function(){ return !this.item.attributes.comments_disabled; },
      set: function(value){
        this.$store.dispatch('updateItem', { itemId: this.item.id, body: { comments_disabled: !value } }).then(function(){
          // Setting the state should be enough to update the view, however
          // this component is not yet smart enough as some elements in the view
          // are conditioned by ERB check viewer.html.erb for comments_enabled? method.
          // TODO: Change conditions in referenced file so it works only with vue.
          window.location.reload();
        })
        },
    },
    hideCopyDrop: function(){
      return this.isOwner || (this.currentOrganization.id != this.itemOrganization.id && this.inCustomStorage);
    },
    inCustomStorage: function(){
      return !!(this.item.attributes.in_custom_storage || this.currentOrganization.attributes.custom_storage);
    },
    showCopyDrop: function(){
      return !this.hideCopyDrop && (this.item.attributes.media || (this.$root.userLoggedIn && !this.currentUser.attributes.is_free))
    },
    shareCopy: function(){
      return `Share ${this.isOwner ? "your" : "this" } ${this.item.attributes.item_type || "drop"}`;
    },
    templatesEnabled: function(){
      const isFeatureOn = this.features?.[featureKey("web-experiment-viewer_templates_feature")];
      return isFeatureOn && this.isOwner && !this.viewOnlyUser && this.currentOrganization.attributes.is_paying;
    },
    webAnnotateRoute: function(){
      if(this.viewOnlyUser){
        return { path: this.$route.path, hash: 'view-only'}
      }else{
        return { name: 'annotate', params: { slug: this.item.id } }
      }
    },
  },
  methods: {
    openDownloadModal: function(){
      $('#downloadModal').modal();
    },
    openCTAEditor: function(e){
      if(this.viewOnlyUser) {
        this.$router.push({ path: this.$route.path, hash: "view-only" })
      }else {
        this.$root.cta.menuOpen = true
      }
    },
    setUtmParams: function(){
      const vm = this;
      setTimeout(function(){
        // these are globally defined functions in the asset pipeline, that make use of HTML5 history to emulate $router
        // we should move them to vue or find a better way to do this in vue components.
        setModalUTM(viewerUtmParams('save_footer_link', null, 'viewer_new'));
        addURLParams({'post_onboarding': JSON.stringify({ 'action': 'copy', 'arguments': { 'item_id': vm.item.id }})});
      }, 200)
    },
    track: track,
    trackClientAnnotate: function(){
      let platform = navigator.platform;
      if(platform.match(/win/i)){
        platform = "windows";
      } else if(platform.match(/mac/i)) {
        platform = "mac";
      } else {
        platform = "chrome";
      }
      track('web_annotate_clicked', { platform });
    },
  }
}
</script>

<style lang="scss" scoped>
@import '@/packs/application.scss';

#add-cta {
  cursor: pointer;
}

</style>